import AboutUsPopUp from './AboutUsPopUp';

export default AboutUsPopUp;
